export default __webpack_public_path__ + "static/media/Disponible_GooglePlay.0be68a01.png";